import {getStatusLabel, getStatusColor} from '@@/core/libraries/adminFunctions'
export default {
    props:{
        status: String
    },
    methods:{
      getStatusLabel,getStatusColor
    }
}
